module.exports = __webpack_public_path__ + "appstore/static/img/banner.97d402e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/assets/banner.png
// module id = OmzQ
// module chunks = 4